import React, { Fragment } from 'react';

const VehicleLate = () => (
  <Fragment>
    <p>
      If there are still cars available, you will receive an automated text message an hour before the end time of your
      booking.
    </p>
    <p>The text message will look something like this:</p>
    <p>
      <i>
        Hi Alex, the Go vehicle (T711611C) you’re driving is available for an additional 4 hours at the rate of $8.0/hr.
        Reply "EXTEND" to extend your booking and earn more money today!
      </i>
    </p>
    <p>
      All you need to do is send a text message reply with the word <b>EXTEND</b> and it will alert our system you've
      made the request.
    </p>
    <p>If your request is successful, you will receive a message like this:</p>
    <p>
      <i>
        Great choice! The Go vehicle (T711611C) you’re driving has been extended for 4 hours. Your booking will now end
        at Mon 5 Aug 11:00 PM.
      </i>
    </p>
    <p>Otherwise, you will be sent a reminder to bring the car back.</p>
  </Fragment>
);

export default VehicleLate;



// WEBPACK FOOTER //
// ./src/components/Static/DriverFaq/VehicleLate.js